import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const LandingTestimonios = ({ producto, initial = [], color = '#1FA3E8' }) => {
  const [items, setItems] = useState(initial);

  useEffect(() => {
    axios.get(`${API}/api/landing/testimonios/${producto}`)
      .then((r) => { if (r.data?.items?.length) setItems(r.data.items); })
      .catch(() => {});
  }, [producto]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-testid={`testimonios-grid-${producto}`}>
      {items.map((t, idx) => (
        <figure key={t.id || `${idx}-${t.nombre}`} className="bg-white/[0.04] border border-white/10 rounded-3xl p-6 flex flex-col" data-testid={`testimonio-${idx}`}>
          <div className="flex gap-1 mb-3" aria-label={`${t.estrellas || 5} estrellas`}>
            {[...Array(t.estrellas || 5)].map((_, i) => (
              <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill={color}><path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 7-6.2-3.7-6.2 3.7 1.6-7L2 9.2l7.1-.6z"/></svg>
            ))}
          </div>
          <blockquote className="text-white/75 text-sm leading-relaxed flex-1">"{t.texto}"</blockquote>
          <figcaption className="mt-5 pt-4 border-t border-white/10">
            <p className="font-black text-sm">{t.nombre}</p>
            {t.lugar ? <p className="text-white/45 text-xs mt-0.5">{t.lugar}</p> : null}
          </figcaption>
        </figure>
      ))}
    </div>
  );
};
